/**
 * Initial state factory for the "spaces" (channels) Vuex module.
 *
 * Returned as a function (rather than a plain object) so Vuex gets a fresh,
 * unshared state tree per store instantiation. `channelData` holds the
 * currently loaded channel, `channelsList` the channel list for an owner,
 * and `followingList`/`followingCount` the current user's followed channels.
 */
export default () => ({
  channelData: {},
  channelsList: [],
  followingList: [],
  followingCount: 0,
});

// Not wired into updates.js as a mutation and not imported elsewhere in the
// app — kept here unused, mirroring the same helper in other channel-like
// modules (e.g. groupchannel/store.js).
export function clearFollowingList(state) {
  state.followingList = [];
  state.followingCount = 0;
}
